import { render, staticRenderFns } from "./AddSuperAdminModal.vue?vue&type=template&id=506e3995&scoped=true&"
import script from "./AddSuperAdminModal.vue?vue&type=script&lang=js&"
export * from "./AddSuperAdminModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSuperAdminModal.vue?vue&type=style&index=0&id=506e3995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e3995",
  null
  
)

export default component.exports